<template>
  <div class="cqjc_btmCon">
    <div style="width:49%;float:right;">
      <div class="listTit" @click="cqjcshow">企业证书</div>
      <div class="cqjc_img">
          <RyzsCov v-if="imgListqy.length>0" :urlimg="urlimg"  :honorCoverValue="imgListqy" style="position: absolute;width:50%;top:45px;" />
          <img  v-else src="@/assets/images/nonenum.png" alt="" style="margin-top:30px;">
      </div>
    </div>
    <div style="width:49%;float:left;">
      <div class="listTit" style="cursor: auto;">农事记录</div>
      <!-- <div class="titnum">
        <span style="float:left;">农事作业记录</span>
        <span style="float:right;margin-right:3%;">本月填报  <span class="numto">{{numTotal}}</span> 条 </span>
      </div> -->
      <div class="cqjc_img" style="background:none;cursor:initial;" v-if="agriculList.length>0">
          <vue-seamless-scroll :data="agriculList"  :class-option="optionSetting">
            <el-timeline>
              <el-timeline-item hide-timestamp v-for="(item,index) in agriculList" :key="index" placement="top">
                <div class="el-timeline-item__timestamp2 is-top">
                    <span>{{ item.landId_dictText }} <span style="float:right;margin-right:2%;">{{ item.startTime }}</span> </span> 
                </div>
                <div class="stCov">
                  <span>{{ item.completeOperTime }} {{ item.chargeUserName }} 在地块上进行 "{{item.missionName}}"</span>
                  <div class="imgList" v-if="item.feedbackImgUrls">
                    <viewer>
                      <img  :src="val.includes('https')?val:urlimg+val" v-for="(val,index) in item.feedbackImgUrls.split(',')"  :key="index"  alt="" class="stCovimg" >
                    </viewer>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </vue-seamless-scroll>
      </div>
      <img  v-else src="@/assets/images/nonenum.png" alt="" style="margin-top:30px;">
    </div>
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="cqjczddialogTableVisible"
      :modal-append-to-body="false"
    >
      <div class="tz_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">企业荣誉</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="24">
            <div class="cqimgTcList" >
              <div class="cqimg" v-for="(item,index) in imgListqy" :key="index">
                  <img :src="urlimg+item.imgurl" @click="showViewer(index)"  alt="">
                  <span class="cqTime">{{item.name}}</span>
              </div>
              <!-- Viewer 容器 -->
              <div v-viewer="viewerOptions" class="images">
                <img v-for="(image, index) in imgListqy" :key="index" :src="urlimg+image.imgurl" style="display: none;">
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RyzsCov from "@/components/cyshow/ryzsCov.vue";
import { MissionPage } from'@/api'
export default {
  props:{
    urlimg:String,
    farmId:String,
    onephoto:Array,
  },
  components: {
    RyzsCov,
  },
  name: "btmcov",
  data(){
    return{
      auths:'KBISPX',
      value1: '',
      cqjczddialogTableVisible: false,
      photo:[],
      agriculList:[],
      imgList:[],
      imgListqy:[],
      pageNo:1,
      pageSize:6,
      numTotal:0,
      viewerOptions:''
    }
  },
  created(){
    this.nsjlCover()
  },
  computed: {
    optionSetting(){
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() {
    this.photo = this.onephoto
    let qiyeList = this.onephoto.map((item,index)=>{
      let arr = []
      item.reportImg.split(',').map((ele,i)=>{
        arr[i] = {
          name:item.reportName,
          imgurl:ele
        }
      })
      item.arr = arr;
      return item;
    })
      let arrary = qiyeList.map(res=>{
          return res.arr
      })
      this.imgListqy = arrary.flat();
  },
  methods:{
    nsjlCover(){
      MissionPage(this.farmId,this.pageNo,this.pageSize).then(res=>{
          this.agriculList = res.result.records
          this.numTotal = res.result.total
      })
    },
    qcguanbi() {
      this.cqjczddialogTableVisible = false;
    },
    cqjcshow() {
        this.cqjczddialogTableVisible = true;
    },
    showViewer(index) {
      // 获取 Viewer 实例
      const viewer = this.$el.querySelector('.images').$viewer
      // 显示指定索引的图片
      viewer.view(index)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "@/assets/css/home.css";
.cqjc_btmCon{
    width: 960px;
    height: 300px;
    position: absolute;
    left:480px;
    bottom: 10px;
    .titnum{
      width: 94%;
      height: 30px;
      line-height: 30px;
      color: #13B87F;
      font-size: 16px;
      display: block;
      overflow: hidden;
      margin-bottom: 10px;
      padding:0 3%;
      .numto{
        color:#EECF0A;font-size:24px;
        font-family: "UnidreamLED";
      }
    }
    .cqjc_img{
      width: 100%;
      height: 234px;
      // background: rgba(13,235,179,0.3);
      border-radius: 6px;
      cursor: pointer;
      overflow: hidden;
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      line-height: 300px;
      margin: 0;
    }
}
/* 定义滚动条样式 */
.cqjc_btmCon::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.cqjc_btmCon::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.cqjc_btmCon::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.listTit{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    font-weight: bold;
    background: url(@/assets/images/listtit.png)no-repeat ;
    background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
    text-shadow: 0px 0px 8px #00FFC2;
    display: block;
    position: relative;
    cursor: pointer;
    &::after {
        content: '';
        position: absolute;
        top: 1px;
        left: 0px;
        width:4px;
        height: 40px;
        background: rgba(41,255,206,1);
        border-radius: 100%;
        animation: flow 5s ease infinite ; 
        filter: blur(6px); 
      }
}

// 弹出开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 29, 20,0.9);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tz_cov_chanye{
	width: 100%;
	height: 42vw;
	/* background: url(../../assets/images/tccovbak.png) no-repeat;
    background-size: 100% 100%; */
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
  .tz_cov_top_tit{
    font-size: 20px;
      font-family: douyuFont;
      color: #fff;
      text-align: center;
      cursor: pointer;
  }

  .ycboxlt{
      width: 94%; margin-left: 2%;
      background: url(../../assets/images/tckuang.png)no-repeat ;
    background-size: 100% 100%;
      padding: 10px;
  }
  .ycboxlt4{
      width: 94%; margin-left: 2%;
      // background: url(../../assets/images/tckuang.png)no-repeat ;
    background-size: 100% 100%;
      padding: 10px;
  }
  .tz_cov_topyqjs{
      width: 100%;
      height:600px;
  }
  .guanbiann{
    width: 28px;
    height: 28px;
    position: absolute;
    right: 2%;
    top: 0.5vw;
    z-index: 9999999999;
    cursor: pointer;
  }
  .tz_cov_topchanye{
    width: 100%;
    height:48px;
    background: url(../../assets/images/tctopback.png)no-repeat ;
    background-size: 100% 100%;
    text-align: center;
    line-height: 48px;
    margin-bottom: 20px;
  }
  .cqimgTcList{
    width: 96%;
    height: 530px;
    margin: 0 auto;
    overflow: auto;
    .cqimg{
      width: 32%;
      height: 237px;
      float: left;
      margin-top: 10px;
      margin-right: 1%;
      overflow: hidden;
      position: relative;
      border-radius: 10px;
      img{
        width: 100%;
        height: 200px;
        border-radius: 10px;
        border: 1px solid rgb(0, 95, 65);
      }
    }
    .cqTime{
      color: #08B375;
      font-size: 16px;
      display: block;
      margin-top: 10px;
    }
  }
  /* 定义滚动条样式 */
  .cqimgTcList::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: rgba(240, 240, 240, 0.1);
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .cqimgTcList::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .0);
  }
  /*定义滑块 内阴影+圆角*/
  .cqimgTcList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
    background-color: rgba(36, 132, 109, .8);
  }
}
// 弹出结束

// 农事记录开始
.stCov {
  width: 100%;
  text-align: left;
  padding-left: 3%;
  padding: 10px;
  box-sizing: border-box;
  background: rgba(24,152,108,0.41);
  border: 1px solid #14A17D;
  // background: rgba(0, 24, 3, 0.65);
  // border: 1px solid #00432b;
  .imgList{
    display: flex;
    padding: 10px 0 0;
    box-sizing: border-box;
    .stCovimg{
      width: 50px;
      height: 40px;
      margin-right: 10px;
      cursor: pointer;
      // border: 1px solid #18bd86;
    }
  }
  span {
    width: 100%;
    font-size: 14px;
    color: #dfdfdf;
    display: block;
    white-space: nowrap; /* 保持文本在一行内显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis;
  }
}

.el-timeline-item__timestamp2 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #fff;
  text-align: left;
  width: 98%;
  height: 28px;
  line-height: 28px;
  margin-left: -1%;
  padding-left: 3%;
  background: url(../../assets/images/jyzt/titleBg.png)0 0 / 100% 100%;
  overflow: hidden;
  display: block;
}
.el-timeline-item{
  padding-top: 10px;
  padding-bottom: 0px;
}

</style>
